<template>
   <br><br>
    <section>
<div class="container-fluid faq">
   <div class="container py-5">
      <div class="mx-auto text-center wow fadeIn" data-wow-delay="0.1s" style="max-width: 500px;">
         
         <h1 class="mb-4">Frequently Asked Questions</h1>
      </div>
      <div class="row">
         <div class="col-lg-6">
            <div class="accordion" id="accordionFAQ1">
               <div class="accordion-item wow fadeIn" data-wow-delay="0.1s">
                  <h2 class="accordion-header" id="headingOne">
                     <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                     What fire safety products does Arch Enterprises offer?
                     </button>
                  </h2>
                  <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne"
                     data-bs-parent="#accordionFAQ1">
                     <div class="accordion-body">
                        We provide FM approved and UL listed fire engines, fire extinguishers, fire pump controllers, and complete fire
                        suppression systems for industrial, commercial, and residential applications.
                     </div>
                  </div>
               </div>
               <div class="accordion-item wow fadeIn" data-wow-delay="0.2s">
                  <h2 class="accordion-header" id="headingTwo">
                     <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                     Are your products FM/UL listed?
                     </button>
                  </h2>
                  <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                     data-bs-parent="#accordionFAQ1">
                     <div class="accordion-body">
                        Yes! We supply FM/UL-listed fire pumps and controllers from top manufacturers,
                        ensuring compliance with global safety standards.
                     </div>
                  </div>
               </div>
               <div class="accordion-item wow fadeIn" data-wow-delay="0.3s">
                  <h2 class="accordion-header" id="headingThree">
                     <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                     Do you offer installation and maintenance services?
                     </button>
                  </h2>
                  <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                     data-bs-parent="#accordionFAQ1">
                     <div class="accordion-body">
                        Absolutely! Our expert team provides installation, testing, and regular maintenance
                        to ensure all fire safety equipment functions efficiently.
                     </div>
                  </div>
               </div>
               <div class="accordion-item wow fadeIn" data-wow-delay="0.4s">
                  <h2 class="accordion-header" id="headingFour">
                     <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseFour" aria-expanded="true" aria-controls="collapseFour">
                     How often should fire pumps be inspected?
                     </button>
                  </h2>
                  <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour"
                     data-bs-parent="#accordionFAQ1">
                     <div class="accordion-body">
                        Fire pumps should be tested weekly and undergo a full annual inspection as per NFPA
                        (National Fire Protection Association) standards.
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div class="col-lg-6">
            <div class="accordion" id="accordionFAQ2">
               <div class="accordion-item wow fadeIn" data-wow-delay="0.5s">
                  <h2 class="accordion-header" id="headingFive">
                     <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                     Do you provide pump performance test for fire pump set?
                     </button>
                  </h2>
                  <div id="collapseFive" class="accordion-collapse collapse" aria-labelledby="headingFive"
                     data-bs-parent="#accordionFAQ2">
                     <div class="accordion-body">
                        Yes! With the help of ultrasonic flometer we provide pump performance test as per FM guidlines.
                     </div>
                  </div>
               </div>
               <div class="accordion-item wow fadeIn" data-wow-delay="0.6s">
                  <h2 class="accordion-header" id="headingSix">
                     <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                     Do you provide training on fire safety equipment usage?
                     </button>
                  </h2>
                  <div id="collapseSix" class="accordion-collapse collapse" aria-labelledby="headingSix"
                     data-bs-parent="#accordionFAQ2">
                     <div class="accordion-body">
                        Yes! We offer fire safety training and demonstrations for businesses, industries,
                        and residential communities.
                     </div>
                  </div>
               </div>
               <div class="accordion-item wow fadeIn" data-wow-delay="0.7s">
                  <h2 class="accordion-header" id="headingSeven">
                     <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                     How can I ensure my fire pump remains operational during an emergency?
                     </button>
                  </h2>
                  <div id="collapseSeven" class="accordion-collapse collapse" aria-labelledby="headingSeven"
                     data-bs-parent="#accordionFAQ2">
                     <div class="accordion-body">
                        ✔ Regular inspections and maintenance<br>
                        ✔ Ensure power backup (diesel engine-driven pumps)<br>
                        ✔ Keep the pump house environment controlled<br>
                        ✔ Perform weekly churn tests
                     </div>
                  </div>
               </div>
               <div class="accordion-item wow fadeIn" data-wow-delay="0.8s">
                  <h2 class="accordion-header" id="headingEight">
                     <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
                     Do you provide customized fire protection solutions?
                     </button>
                  </h2>
                  <div id="collapseEight" class="accordion-collapse collapse" aria-labelledby="headingEight"
                     data-bs-parent="#accordionFAQ2">
                     <div class="accordion-body">
                        Yes, we design fire protection systems tailored to specific industrial, commercial,
                        and residential needs.
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>
</section>
</template>
<script>
export default{
    name: "FaqSection",
};
</script>
<style lang="scss" scoped>

</style>
